import { useEffect, useState } from "react";
import MenuBar from "../MenuBar";
import { apiFetch } from "../api";

import { useI18n } from "../i18n/I18nContext";

export default function ConsultationQualiteStackAboutage() {
  const { t, ui } = useI18n();

  const [rows, setRows] = useState([]);
  const [filteredRows, setFilteredRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState("");
  const [details, setDetails] = useState(null);

  const [filters, setFilters] = useState({
    date: "", operateur: "", idStack: "", conformite: "",
  });

  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });

  useEffect(() => {
    (async () => {
      try {
        const r = await apiFetch("/api/qualite/stack_planeite/list");
        const j = await r.json();
        setRows(j || []);
        setFilteredRows(j || []);
        setLoading(false);
      } catch {
        setErr("Erreur lors du chargement");
        setLoading(false);
      }
    })();
  }, []);

  useEffect(() => {
    let result = [...rows];
    if (filters.date) result = result.filter(r => r.Date?.toLowerCase().includes(filters.date.toLowerCase()));
    if (filters.operateur) result = result.filter(r => r.Operateur?.toLowerCase().includes(filters.operateur.toLowerCase()));
    if (filters.idStack) result = result.filter(r => r.IDStack?.toLowerCase().includes(filters.idStack.toLowerCase()));
    if (filters.conformite) result = result.filter(r => r.Conformite === filters.conformite);
    setFilteredRows(result);
  }, [filters, rows]);

  const handleSort = (key) => {
    const direction = sortConfig.key === key && sortConfig.direction === "asc" ? "desc" : "asc";
    setSortConfig({ key, direction });
    const sorted = [...filteredRows].sort((a, b) => {
      const aVal = a[key] || "", bVal = b[key] || "";
      if (!isNaN(aVal) && !isNaN(bVal)) return direction === "asc" ? aVal - bVal : bVal - aVal;
      return direction === "asc" ? String(aVal).localeCompare(String(bVal)) : String(bVal).localeCompare(String(aVal));
    });
    setFilteredRows(sorted);
  };

  const exportToCSV = () => {
    if (!filteredRows.length) return;
    const headers = ["Index","Date","Opérateur","ID Stack","Conformité","Résistance Collage","Résistance Collage Commentaire","Planéité","Planéité Commentaire","Autres Défauts","Autres Défauts Commentaire"];
    const csvRows = filteredRows.map(r => [r.index||"",r.Date||"",r.Operateur||"",r.IDStack||"",r.Conformite||"",r.ResistanceCollage?"OUI":"NON",r.ResistanceCollageComment||"",r.Planeite?"OUI":"NON",r.PlaneiteComment||"",r.AutresDefauts?"OUI":"NON",r.AutresDefautsComment||""]);
    const csv = [headers.join(","), ...csvRows.map(row => row.map(c => `"${String(c).replace(/"/g,'""')}"`).join(","))].join("\n");
    const blob = new Blob(["\ufeff" + csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url; a.download = `controle_stack_aboutage_${new Date().toISOString().split("T")[0]}.csv`;
    a.click(); URL.revokeObjectURL(url);
  };

  const getSortIcon = (key) => {
    if (sortConfig.key !== key) return <span style={S.sortIcon}>⇅</span>;
    return <span style={{ ...S.sortIcon, color: "#E6FF3E" }}>{sortConfig.direction === "asc" ? "▲" : "▼"}</span>;
  };

  const conformeBadge = (val) => (
    <span style={{ ...S.badge, ...(val === "CONFORME" ? S.badgeOk : S.badgeNok) }}>
      {val === "CONFORME" ? "✓ CONFORME" : "✗ NON CONFORME"}
    </span>
  );

  const statCount = {
    total: rows.length,
    conforme: rows.filter(r => r.Conformite === "CONFORME").length,
    nonConforme: rows.filter(r => r.Conformite === "NON CONFORME").length,
  };

  return (
    <>
      <style>{globalCSS}</style>

      <div style={S.page}>
        <MenuBar active="qualite" />

        <div style={S.wrap}>

          {/* ── HEADER ── */}
          <div style={S.header}>
            <div>
              <div style={S.headerTitle}>Contrôle Stack Aboutage</div>
              <div style={S.headerSub}>Consultation & analyse des contrôles de planéité</div>
            </div>
            <div style={S.statsRow}>
              <div style={S.statCard}>
                <div style={S.statNum}>{statCount.total}</div>
                <div style={S.statLabel}>Total</div>
              </div>
              <div style={{ ...S.statCard, borderColor: "#4ade80" }}>
                <div style={{ ...S.statNum, color: "#4ade80" }}>{statCount.conforme}</div>
                <div style={S.statLabel}>Conformes</div>
              </div>
              <div style={{ ...S.statCard, borderColor: "#f87171" }}>
                <div style={{ ...S.statNum, color: "#f87171" }}>{statCount.nonConforme}</div>
                <div style={S.statLabel}>Non conformes</div>
              </div>
            </div>
          </div>

          {/* ── PANEL ── */}
          <div style={S.panel}>

            {/* ── FILTRES ── */}
            <div style={S.filterBar}>
              {[
                { key: "date", placeholder: "Date", icon: "📅" },
                { key: "operateur", placeholder: "Opérateur", icon: "👤" },
                { key: "idStack", placeholder: "ID Stack", icon: "🔖" },
              ].map(({ key, placeholder, icon }) => (
                <div key={key} style={S.filterWrap}>
                  <span style={S.filterIcon}>{icon}</span>
                  <input
                    className="woodoo-input"
                    type="text"
                    placeholder={placeholder}
                    value={filters[key]}
                    onChange={e => setFilters({ ...filters, [key]: e.target.value })}
                    style={S.filterInput}
                  />
                </div>
              ))}

              <div style={S.filterWrap}>
                <span style={S.filterIcon}>⚙️</span>
                <select
                  className="woodoo-input"
                  value={filters.conformite}
                  onChange={e => setFilters({ ...filters, conformite: e.target.value })}
                  style={S.filterInput}
                >
                  <option value="">Toutes conformités</option>
                  <option value="CONFORME">CONFORME</option>
                  <option value="NON CONFORME">NON CONFORME</option>
                </select>
              </div>

              <button className="woodoo-btn-lime" style={S.exportBtn} onClick={exportToCSV}>
                📥 Export CSV
              </button>
              <button className="woodoo-btn-reset" style={S.resetBtn}
                onClick={() => setFilters({ date: "", operateur: "", idStack: "", conformite: "" })}>
                ✕ Reset
              </button>
            </div>

            <div style={S.resultCount}>
              <span style={S.resultDot} />
              {filteredRows.length} résultat(s) sur {rows.length}
            </div>

            {loading && <div style={S.loading}><span className="woodoo-spin">⟳</span> {ui("Chargement…")}</div>}
            {err && <div style={S.errMsg}>{err}</div>}

            {/* ── TABLE ── */}
            {!loading && (
              <div style={S.tableWrap} className="woodoo-scroll">
                <table style={S.table}>
                  <thead>
                    <tr>
                      {[
                        ["index", "#"],
                        ["Date", "Date"],
                        ["Operateur", "Opérateur"],
                        ["IDStack", "ID Stack"],
                        ["Conformite", "Conformité"],
                      ].map(([key, label]) => (
                        <th key={key} className="woodoo-th" style={S.th} onClick={() => handleSort(key)}>
                          {label} {getSortIcon(key)}
                        </th>
                      ))}
                      <th style={{ ...S.th, cursor: "default" }}>Détails</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredRows.map((r, i) => (
                      <tr key={r.index} className="woodoo-tr" style={i % 2 === 0 ? S.trEven : S.trOdd}>
                        <td style={S.tdIndex}>{r.index}</td>
                        <td style={S.td}>{r.Date}</td>
                        <td style={S.td}>{r.Operateur}</td>
                        <td style={{ ...S.td, ...S.tdStack }}>{r.IDStack}</td>
                        <td style={S.td}>{conformeBadge(r.Conformite)}</td>
                        <td style={S.td}>
                          <button className="woodoo-voir" style={S.voirBtn} onClick={() => setDetails(r)}>
                            Voir →
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>

        {/* ── MODAL ── */}
        {details && (
          <div style={S.backdrop} onClick={() => setDetails(null)}>
            <div style={S.modal} onClick={e => e.stopPropagation()}>

              {/* Header modal */}
              <div style={S.modalHeader}>
                <div>
                  <div style={S.modalTitle}>Détails — Contrôle Stack Aboutage</div>
                  <div style={S.modalSub}>#{details.index} · {details.IDStack} · {details.Date}</div>
                </div>
                <button style={S.modalClose} onClick={() => setDetails(null)}>✕</button>
              </div>

              {/* Badge conformité */}
              <div style={S.modalConformite}>{conformeBadge(details.Conformite)}</div>

              {/* Opérateur */}
              <div style={S.operateurTag}>
                <span style={S.operateurIcon}>👤</span>
                <span style={S.operateurName}>{details.Operateur || "—"}</span>
              </div>

              {/* ── DÉFAUTS ── */}
              <div style={S.sectionTitle}>Défauts détectés</div>
              <div style={S.defGrid}>
                {[
                  ["🔗 Résistance Collage", details.ResistanceCollage, details.ResistanceCollageComment],
                  ["📐 Planéité / rectitude", details.Planeite, details.PlaneiteComment],
                  ["⚠️ Autres défauts", details.AutresDefauts, details.AutresDefautsComment],
                ].map(([label, val, comment]) => (
                  <div key={label} style={{ ...S.defCard, borderColor: val ? "#f87171" : "#4ade80" }}>
                    <div style={S.defCardLabel}>{label}</div>
                    <div style={val ? S.defOui : S.defNon}>
                      {val ? "⚠ OUI" : "✓ NON"}
                    </div>
                    {comment && <div style={S.defComment}>💬 {comment}</div>}
                  </div>
                ))}
              </div>

              {/* ── RÉSUMÉ CONFORMITÉ ── */}
              <div style={S.sectionTitle}>Résumé</div>
              <div style={{
                ...S.resumeBox,
                borderColor: details.Conformite === "CONFORME" ? "#4ade80" : "#f87171",
                background: details.Conformite === "CONFORME"
                  ? "rgba(74,222,128,0.08)"
                  : "rgba(248,113,113,0.08)",
              }}>
                <div style={S.resumeIcon}>
                  {details.Conformite === "CONFORME" ? "✅" : "❌"}
                </div>
                <div>
                  <div style={{ fontWeight: 800, fontSize: 15, color: details.Conformite === "CONFORME" ? "#4ade80" : "#f87171" }}>
                    {details.Conformite}
                  </div>
                  <div style={{ fontSize: 12, color: "#64748b", marginTop: 2 }}>
                    {[details.ResistanceCollage, details.Planeite, details.AutresDefauts].filter(Boolean).length} défaut(s) détecté(s) sur 3 critères
                  </div>
                </div>
              </div>

              <button className="woodoo-btn-lime" style={S.closeBtn} onClick={() => setDetails(null)}>
                Fermer
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

/* ─────────────────────────────────────────────
   CSS GLOBAL
───────────────────────────────────────────── */
const globalCSS = `
  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800;900&display=swap');
  * { box-sizing: border-box; }
  body { font-family: 'Inter', sans-serif; }

  .woodoo-input {
    background: #0d2233 !important;
    color: #e2e8f0 !important;
    border: 1px solid #1e3a50 !important;
    transition: border-color 0.2s, box-shadow 0.2s !important;
    outline: none !important;
  }
  .woodoo-input:focus {
    border-color: #E6FF3E !important;
    box-shadow: 0 0 0 3px rgba(230,255,62,0.15) !important;
  }
  .woodoo-input option { background: #0d2233; }

  .woodoo-th:hover { background: #1e3a50 !important; color: #E6FF3E !important; }

  .woodoo-tr { transition: background 0.15s !important; }
  .woodoo-tr:hover td { background: #1a3248 !important; }

  .woodoo-voir { transition: background 0.2s, transform 0.15s, box-shadow 0.2s !important; }
  .woodoo-voir:hover {
    background: #fff !important; color: #000 !important;
    transform: translateY(-1px) !important;
    box-shadow: 0 4px 12px rgba(230,255,62,0.3) !important;
  }

  .woodoo-btn-lime { transition: background 0.2s, transform 0.15s, box-shadow 0.2s !important; }
  .woodoo-btn-lime:hover {
    background: #fff !important; transform: translateY(-1px) !important;
    box-shadow: 0 4px 14px rgba(230,255,62,0.35) !important;
  }

  .woodoo-btn-reset { transition: background 0.2s, transform 0.15s !important; }
  .woodoo-btn-reset:hover { background: #dc2626 !important; transform: translateY(-1px) !important; }

  .woodoo-scroll::-webkit-scrollbar { height: 6px; }
  .woodoo-scroll::-webkit-scrollbar-track { background: #0d1b2a; }
  .woodoo-scroll::-webkit-scrollbar-thumb { background: #E6FF3E; border-radius: 3px; }

  @keyframes spin { to { transform: rotate(360deg); } }
  .woodoo-spin { display: inline-block; animation: spin 1s linear infinite; }

  @keyframes fadeIn { from { opacity:0; transform: translateY(6px); } to { opacity:1; transform: translateY(0); } }
  .woodoo-tr { animation: fadeIn 0.2s ease both; }

  @keyframes slideUp { from { opacity:0; transform: translateY(20px) scale(0.98); } to { opacity:1; transform: translateY(0) scale(1); } }
`;

/* ─────────────────────────────────────────────
   STYLES
───────────────────────────────────────────── */
const S = {
  page: { background: "linear-gradient(160deg,#041e2e 0%,#063549 60%,#052a3e 100%)", minHeight: "100vh", color: "#e2e8f0", fontFamily: "'Inter',sans-serif" },
  wrap: { padding: "24px 28px", maxWidth: 1200, margin: "0 auto" },

  header: { display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 28, flexWrap: "wrap", gap: 16 },
  headerTitle: { fontSize: 28, fontWeight: 900, background: "linear-gradient(90deg,#fff 0%,#E6FF3E 100%)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent" },
  headerSub: { fontSize: 13, color: "#94a3b8", marginTop: 4 },
  statsRow: { display: "flex", gap: 12 },
  statCard: { background: "rgba(255,255,255,0.04)", border: "1px solid #1e3a50", borderRadius: 12, padding: "12px 20px", textAlign: "center", backdropFilter: "blur(8px)" },
  statNum: { fontSize: 26, fontWeight: 900, color: "#fff" },
  statLabel: { fontSize: 11, color: "#94a3b8", marginTop: 2, textTransform: "uppercase", letterSpacing: "0.08em" },

  panel: { background: "rgba(255,255,255,0.03)", borderRadius: 16, border: "1px solid #1e3a50", padding: 24, backdropFilter: "blur(12px)" },

  filterBar: { display: "flex", gap: 10, marginBottom: 16, flexWrap: "wrap", alignItems: "center" },
  filterWrap: { flex: 1, minWidth: 160, position: "relative", display: "flex", alignItems: "center" },
  filterIcon: { position: "absolute", left: 10, fontSize: 14, zIndex: 1, pointerEvents: "none" },
  filterInput: { width: "100%", padding: "9px 12px 9px 32px", borderRadius: 8, fontSize: 13, fontWeight: 500 },
  exportBtn: { padding: "9px 18px", borderRadius: 8, fontWeight: 700, background: "#E6FF3E", border: "none", cursor: "pointer", fontSize: 13, color: "#000", whiteSpace: "nowrap" },
  resetBtn: { padding: "9px 18px", borderRadius: 8, fontWeight: 700, background: "#ef4444", color: "#fff", border: "none", cursor: "pointer", fontSize: 13, whiteSpace: "nowrap" },
  resultCount: { display: "flex", alignItems: "center", gap: 8, marginBottom: 14, fontSize: 13, fontWeight: 600, color: "#E6FF3E" },
  resultDot: { width: 8, height: 8, borderRadius: "50%", background: "#E6FF3E", boxShadow: "0 0 6px #E6FF3E" },

  loading: { textAlign: "center", padding: 40, fontSize: 16, color: "#94a3b8" },
  errMsg: { textAlign: "center", padding: 20, color: "#f87171", fontWeight: 600 },

  tableWrap: { overflowX: "auto", borderRadius: 12, border: "1px solid #1e3a50" },
  table: { width: "100%", borderCollapse: "collapse", fontSize: 13 },
  th: { padding: "13px 16px", background: "#071e2f", color: "#94a3b8", fontWeight: 700, fontSize: 11, textTransform: "uppercase", letterSpacing: "0.07em", cursor: "pointer", userSelect: "none", whiteSpace: "nowrap", borderBottom: "1px solid #1e3a50" },
  td: { padding: "12px 16px", borderBottom: "1px solid #0f2a3d", color: "#cbd5e1", textAlign: "center", whiteSpace: "nowrap" },
  tdIndex: { padding: "12px 16px", borderBottom: "1px solid #0f2a3d", color: "#64748b", fontSize: 11, fontWeight: 600, textAlign: "center" },
  tdStack: { color: "#E6FF3E", fontWeight: 700, fontFamily: "monospace", fontSize: 12 },
  trEven: { background: "transparent" },
  trOdd: { background: "rgba(255,255,255,0.015)" },
  sortIcon: { marginLeft: 4, fontSize: 10, color: "#64748b" },

  badge: { display: "inline-flex", alignItems: "center", padding: "4px 10px", borderRadius: 20, fontWeight: 700, fontSize: 11, letterSpacing: "0.05em" },
  badgeOk: { background: "rgba(74,222,128,0.15)", color: "#4ade80", border: "1px solid rgba(74,222,128,0.3)" },
  badgeNok: { background: "rgba(248,113,113,0.15)", color: "#f87171", border: "1px solid rgba(248,113,113,0.3)" },

  voirBtn: { padding: "6px 14px", borderRadius: 6, cursor: "pointer", background: "#E6FF3E", fontWeight: 700, border: "none", fontSize: 12, color: "#000" },

  backdrop: { position: "fixed", inset: 0, background: "rgba(0,0,0,0.75)", backdropFilter: "blur(4px)", display: "flex", justifyContent: "center", alignItems: "center", padding: 20, zIndex: 200 },
  modal: { background: "linear-gradient(160deg,#071e2f 0%,#0a2a40 100%)", color: "#e2e8f0", borderRadius: 20, padding: 28, width: "95%", maxWidth: 680, maxHeight: "90vh", overflowY: "auto", border: "1px solid #1e3a50", boxShadow: "0 25px 60px rgba(0,0,0,0.6)", animation: "slideUp 0.25s ease" },
  modalHeader: { display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 12 },
  modalTitle: { fontSize: 20, fontWeight: 900, background: "linear-gradient(90deg,#fff,#E6FF3E)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent" },
  modalSub: { fontSize: 12, color: "#64748b", marginTop: 4 },
  modalClose: { background: "rgba(255,255,255,0.08)", border: "1px solid #1e3a50", borderRadius: 8, color: "#94a3b8", cursor: "pointer", fontSize: 16, padding: "4px 10px" },
  modalConformite: { marginBottom: 12 },

  operateurTag: { display: "inline-flex", alignItems: "center", gap: 8, background: "rgba(255,255,255,0.05)", border: "1px solid #1e3a50", borderRadius: 20, padding: "6px 14px", marginBottom: 20 },
  operateurIcon: { fontSize: 14 },
  operateurName: { fontSize: 13, fontWeight: 700, color: "#e2e8f0" },

  sectionTitle: { fontSize: 11, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.1em", color: "#64748b", borderBottom: "1px solid #1e3a50", paddingBottom: 8, marginBottom: 14, marginTop: 24 },

  defGrid: { display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))", gap: 10 },
  defCard: { background: "rgba(255,255,255,0.03)", borderRadius: 12, border: "1px solid", padding: "14px 16px" },
  defCardLabel: { fontSize: 11, color: "#94a3b8", marginBottom: 8, fontWeight: 600 },
  defComment: { fontSize: 11, color: "#64748b", marginTop: 8, fontStyle: "italic", lineHeight: 1.4 },
  defOui: { fontWeight: 800, color: "#f87171", fontSize: 15 },
  defNon: { fontWeight: 800, color: "#4ade80", fontSize: 15 },

  resumeBox: { display: "flex", alignItems: "center", gap: 14, borderRadius: 12, border: "1px solid", padding: "16px 20px", marginBottom: 8 },
  resumeIcon: { fontSize: 28 },

  closeBtn: { width: "100%", marginTop: 24, padding: 14, borderRadius: 10, fontWeight: 900, fontSize: 14, background: "#E6FF3E", cursor: "pointer", border: "none", color: "#000", letterSpacing: "0.05em" },
};
